import { render, staticRenderFns } from "./AddBenefitModal.vue?vue&type=template&id=67c1c69e&scoped=true"
import script from "./AddBenefitModal.vue?vue&type=script&lang=js"
export * from "./AddBenefitModal.vue?vue&type=script&lang=js"
import style0 from "./AddBenefitModal.vue?vue&type=style&index=0&id=67c1c69e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c1c69e",
  null
  
)

export default component.exports